export enum CATEGORIES_KEY {
  CATEGORY_LIVE_M = "live_m",
  CATEGORY_LIVE_I = "live_i",
  CATEGORY_EVENT_M = "event_m",
  CATEGORY_EVENT_I = "event_i",
  CATEGORY_STORE_I = "store_i",
  CATEGORY_CARP_M = "carp_m",
  CATEGORY_CARP_I = "carp_i",
  CATEGORY_EVAL_I = "eval_i",
  CATEGORY_OTHER_M = "other_m",
}

export const CATEGORIES = {
  [CATEGORIES_KEY.CATEGORY_LIVE_M]: "ライブ鯉（動画）",
  [CATEGORIES_KEY.CATEGORY_LIVE_I]: "ライブ鯉（写真）",
  [CATEGORIES_KEY.CATEGORY_EVENT_M]: "店頭イベント（動画）",
  [CATEGORIES_KEY.CATEGORY_EVENT_I]: "店頭イベント（写真）",
  [CATEGORIES_KEY.CATEGORY_STORE_I]: "飼育資材ストア（写真）",
  [CATEGORIES_KEY.CATEGORY_CARP_M]: "錦鯉販売（動画）",
  [CATEGORIES_KEY.CATEGORY_CARP_I]: "錦鯉販売（写真）",
  [CATEGORIES_KEY.CATEGORY_EVAL_I]: "品評会（写真）",
  [CATEGORIES_KEY.CATEGORY_OTHER_M]: "その他（動画）",
};

export const CATEGORIES_SHOW = {
  [CATEGORIES_KEY.CATEGORY_EVAL_I]: "品評会（写真）",
};

export const CATEGORIES_ARRAY = [
  {
    id: CATEGORIES_KEY.CATEGORY_LIVE_M,
    name: CATEGORIES[CATEGORIES_KEY.CATEGORY_LIVE_M],
  },
  {
    id: CATEGORIES_KEY.CATEGORY_LIVE_I,
    name: CATEGORIES[CATEGORIES_KEY.CATEGORY_LIVE_I],
  },
  {
    id: CATEGORIES_KEY.CATEGORY_EVENT_M,
    name: CATEGORIES[CATEGORIES_KEY.CATEGORY_EVENT_M],
  },
  {
    id: CATEGORIES_KEY.CATEGORY_EVENT_I,
    name: CATEGORIES[CATEGORIES_KEY.CATEGORY_EVENT_I],
  },
  {
    id: CATEGORIES_KEY.CATEGORY_STORE_I,
    name: CATEGORIES[CATEGORIES_KEY.CATEGORY_STORE_I],
  },
  {
    id: CATEGORIES_KEY.CATEGORY_CARP_M,
    name: CATEGORIES[CATEGORIES_KEY.CATEGORY_CARP_M],
  },
  {
    id: CATEGORIES_KEY.CATEGORY_CARP_I,
    name: CATEGORIES[CATEGORIES_KEY.CATEGORY_CARP_I],
  },
  {
    id: CATEGORIES_KEY.CATEGORY_EVAL_I,
    name: CATEGORIES[CATEGORIES_KEY.CATEGORY_EVAL_I],
  },
  {
    id: CATEGORIES_KEY.CATEGORY_OTHER_M,
    name: CATEGORIES[CATEGORIES_KEY.CATEGORY_OTHER_M],
  },
];

export enum TYPE_KEY {
  IMAGE = "image",
  MOVIE = "movie",
}

export const TYPES = {
  [TYPE_KEY.IMAGE]: "写真",
  [TYPE_KEY.MOVIE]: "動画",
};

export const TYPES_ARRAY = [
  { id: TYPE_KEY.MOVIE, name: TYPES[TYPE_KEY.MOVIE] },
  { id: TYPE_KEY.IMAGE, name: TYPES[TYPE_KEY.IMAGE] },
];

export enum STATUS_KEY {
  UPLOADING = "upload",
  WAIT = "wait",
  COMPLETE = "complete",
  ERROR = "error",
}

export const STATUSES = {
  [STATUS_KEY.UPLOADING]: "アップロード中",
  [STATUS_KEY.WAIT]: "待機中",
  [STATUS_KEY.COMPLETE]: "完了",
  [STATUS_KEY.ERROR]: "エラー",
};

export const STATUSES_ARRAY = [
  { id: STATUS_KEY.UPLOADING, name: STATUSES[STATUS_KEY.UPLOADING] },
  { id: STATUS_KEY.WAIT, name: STATUSES[STATUS_KEY.WAIT] },
  { id: STATUS_KEY.COMPLETE, name: STATUSES[STATUS_KEY.COMPLETE] },
  { id: STATUS_KEY.ERROR, name: STATUSES[STATUS_KEY.ERROR] },
];
